export default __webpack_public_path__ + "static/media/failure.e7d38e92.svg";